var map = {
	"./at.svg": "137f",
	"./ch.svg": "7306",
	"./de.svg": "1a15",
	"./dk.svg": "6980",
	"./fi.svg": "d0a1",
	"./no.svg": "24a3",
	"./se.svg": "bdd9",
	"./uk.svg": "ec6d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "fc43";